/**
 * "Add to Chrome": the extension's store page (Admin → System, `extension.storeUrl`). The listing is unlisted during
 * the beta (decision 106), so this link is how people find it. Nothing while the setting is empty.
 */
import { ExternalLink } from 'lucide-react';

export function AddToChrome({ url }: { url: string | null | undefined }) {
  if (!url) return null;
  return (
    <a href={url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 rounded-xl bg-primary px-3.5 py-2 text-xs font-semibold text-primary-foreground">
      Add to Chrome<ExternalLink className="h-3.5 w-3.5" />
    </a>
  );
}
